// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-1c825080]{color:#000}[data-v-1c825080] .fc-daygrid-day-number{color:#000!important}[data-v-1c825080] .fc-daygrid-day-top{-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;font-weight:700!important}#calendar-cheapest-month[data-v-1c825080]  .fc-daygrid-day:hover{background-color:rgba(179,214,255,.3);cursor:pointer}", ""]);
// Exports
module.exports = exports;
